import React, {Component} from 'react';
import {objectArray} from "../table_component"
import './row_table.scss';



class RowTable extends Component<objectArray> {
    convertByteToMb(value: any){
      return Number(value * 0.000001 ).toString().substr(0, 4);
    }
    render() {
        return (
            <tr className={'c15_rowTable'}>
                <td><p className={"td-title my-0"}>{this.props.title}</p></td>
                <td className={"d-none d-md-table-cell"}>{this.convertByteToMb(this.props.size) + 'MB'}</td>
                <td className={"text-sm-right text-md-left"}>
                    <a className={"d-none d-md-table-cell"} href={this.props.url} download>Download</a>
                    <a className={"pr-0 d-sm-table-cell d-md-none float-right"} href={this.props.url} download>
                        <img src="https://svgpngicons.com/jpg/cloud-download-symbol-ico.jpg"
                             className="img-download" alt="download"/>
                    </a>
                </td>
            </tr>
        );
    }
}


export default RowTable;